import { css } from "@emotion/css";
import React, { useMemo } from "react";
import { TextSecondary } from "../../components/DesignSystem/DesignSystemText";

export type EmptyKudosType =
  | "receieved"
  | "sent"
  | "notFound"
  | "communityNotFound"
  | "communityHasNoTokens"
  | "tokenHasNoRequests"
  | "communityHasNoMembers"
  | "communityHasNoRequests"
  | ""
  | null;

interface Props {
  kudosEmptySection: EmptyKudosType;
}

const EmptyKudos: React.FC<Props> = ({ kudosEmptySection }: Props) => {
  const emptyString = useMemo(() => {
    switch (kudosEmptySection) {
      case "receieved":
        return "Contribute to a community and receive a Kudos";
      case "sent":
        return "No Kudos yet, send one now";
      case "notFound":
        return "This profile doesn't exist on Kudos yet";
      case "communityNotFound":
        return "This community doesn't exist on Kudos yet";
      case "communityHasNoTokens":
        return "No tokens found for this community";
      case "tokenHasNoRequests":
        return "No requests for this page";
      case "communityHasNoMembers":
        return "No members found for this community";
      case "communityHasNoRequests":
        return "No requests for this community";
      default:
        return "";
    }
  }, [kudosEmptySection]);

  const icon = useMemo(() => {
    switch (kudosEmptySection) {
      case "tokenHasNoRequests":
        return "✨";
      case "communityHasNoRequests":
        return "✨";
      default:
        return "👋";
    }
  }, [kudosEmptySection]);

  return (
    <div className="mx-auto flex justify-center flex-col items-center mt-[20vh]">
      <div
        className={css`
          font-size: 80px;
        `}
      >
        {icon}
      </div>

      <TextSecondary
        className={css`
          font-weight: 600;
          font-size: 18px;
          margin-top: 10px;
        `}
      >
        {emptyString}
      </TextSecondary>
    </div>
  );
};

export default EmptyKudos;
